let React =        require("react");
const {  Route, Switch  } = require('react-router-dom');

const { encodeUriWithParentheses } = require("../../../util/Utilities.js");

let LibrariesHub = require("../../../controls/hub/LibrariesHub.jsx");
let PackagesHub =  require("../../../controls/hub/PackagesHub.jsx");
let Model3DHub =   require("../../../controls/hub/3DModelsHub.jsx");
let TrashHub =     require("../../../controls/hub/TrashHub.jsx");

let SiteHeader =   require("../../../controls/SiteHeader.jsx");
let CoverHub =     require("../../../controls/hub/CoverHub.jsx");
let Footer =       require("../../../controls/Footer.jsx");

class RouterHubs extends React.Component {

    constructor() {
        super()

        this.onSearch = this.onSearch.bind(this);
        this.onSectionName = this.onSectionName.bind(this);
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    onSectionName(sectionName){
        this.setState({ sectionName })
    }

    getConfig(){
        return { hub: this.props.currentHub, onOpen: this.props.onOpen, onClose: this.props.onClose, setError: this.props.setError,
                setLoading: this.props.setLoading, setConfirmation: this.props.setConfirmation}
    }

    render() {
        if(!this.props.isLogin){ return <div></div>}

        let { currentHub } = this.props;

        return  <div className="hub">
                    <SiteHeader type="Hub" onSearch={this.onSearch} baseUrl="/start"/>

                    <CoverHub {...this.props} />

                    { currentHub &&
                        <Switch>
                            <Route exact path={`/hubs/${currentHub.id}-${encodeUriWithParentheses(currentHub.name)}/libraries`} render={props => <LibrariesHub {...this.props} {...props}  {...this.getConfig()}/>}/>
                            <Route exact path={`/hubs/${currentHub.id}-${encodeUriWithParentheses(currentHub.name)}/packages`} render={props => <PackagesHub {...this.props} {...props} {...this.getConfig()}/>}/>
                            <Route exact path={`/hubs/${currentHub.id}-${encodeUriWithParentheses(currentHub.name)}/3dmodels`} render={props => <Model3DHub {...this.props} {...props}  {...this.getConfig()}/>}/>
                            <Route exact path={`/hubs/${currentHub.id}-${encodeUriWithParentheses(currentHub.name)}/trash`} render={props => <TrashHub {...this.props} {...props}  {...this.getConfig()}/>}/>
                        </Switch>
                    }

                    <Footer/>
                </div>
    }
}

module.exports = RouterHubs;
